import type { CSSProperties, ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  flush?: boolean;
  hover?: boolean;
}

/** Surface card. Wraps the legacy `.card` class. */
export function Card({ children, className, style, flush, hover }: CardProps) {
  const classes = [
    "card",
    flush ? "card--flush" : "",
    hover ? "card--hover" : "",
    className ?? "",
  ].filter(Boolean).join(" ");
  return <div className={classes} style={style}>{children}</div>;
}

interface CardHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

export function CardHeader({ title, subtitle, actions }: CardHeaderProps) {
  return (
    <div className="card-header">
      <div className="min-w-0">
        <div className="card-title">{title}</div>
        {subtitle && <div className="card-subtitle">{subtitle}</div>}
      </div>
      {actions && <div className="card-actions">{actions}</div>}
    </div>
  );
}
